import { Icon } from '@iconify/react';
import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

const Navbar: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      window.location.hash = sectionId;
    }
    setMobileOpen(false);
  };

  const navItems = [
    { label: 'Home', sectionId: 'hero' },
    { label: 'Services', sectionId: 'services' },
    { label: 'About', sectionId: 'about' },
    { label: 'Testimonials', sectionId: 'testimonials' },
    { label: 'Contact', sectionId: 'contactus' },
  ];

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        textAlign: 'center',
        background: (theme) => theme.palette.background.default,
        height: '100%',
      }}
    >
      <Typography
        variant='h6'
        sx={{ my: 2, color: 'primary.main', fontWeight: 'bold' }}
      >
        Skyfall Enterprises
      </Typography>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.label} disablePadding>
            <ListItemButton
              sx={{ textAlign: 'center', color: '#fff' }}
              onClick={() => scrollToSection(item.sectionId)}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding>
          <ListItemButton
            sx={{ textAlign: 'center', justifyContent: 'center' }}
            onClick={() => scrollToSection('contactus')}
          >
            <Button
              variant='contained'
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': { backgroundColor: '#6a00d6' },
                borderRadius: '20px',
                textTransform: 'none',
                padding: '8px 20px',
                width: '80%',
              }}
            >
              Contact Us
            </Button>
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <AppBar
      component='nav'
      position='static'
      sx={{ background: 'transparent', boxShadow: 'none', padding: '1rem 0' }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Icon
            icon='mdi:alpha-s-box'
            width='40'
            height='40'
            style={{ marginRight: '10px', color: '#fff' }}
          />
          <Typography
            variant='h6'
            component='div'
            sx={{ color: '#fff', fontWeight: 'bold' }}
          >
            Skyfall Enterprises
          </Typography>
        </Box>

        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3 }}>
          {navItems.map((item) => (
            <Button
              key={item.label}
              color='inherit'
              sx={{ color: '#fff', textTransform: 'none' }}
              onClick={() => scrollToSection(item.sectionId)}
            >
              {item.label}
            </Button>
          ))}
        </Box>

        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <Button
            variant='contained'
            onClick={() => scrollToSection('contactus')}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': { backgroundColor: '#6a00d6' },
              borderRadius: '20px',
              textTransform: 'none',
              padding: '8px 20px',
            }}
          >
            Contact Us
          </Button>
        </Box>

        <IconButton
          color='inherit'
          aria-label='open drawer'
          edge='end'
          onClick={handleDrawerToggle}
          sx={{ display: { md: 'none' }, color: '#fff' }}
        >
          <Icon icon='mdi:menu' />
        </IconButton>
      </Toolbar>

      <Box component='nav'>
        <Drawer
          variant='temporary'
          anchor='right'
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: 240,
              background: 'background.default',
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </AppBar>
  );
};

export default Navbar;
